import { render, staticRenderFns } from "./OtpMailChoosing.vue?vue&type=template&id=0a74fe92&scoped=true"
import script from "./OtpMailChoosing.vue?vue&type=script&lang=js"
export * from "./OtpMailChoosing.vue?vue&type=script&lang=js"
import style0 from "./OtpMailChoosing.vue?vue&type=style&index=0&id=0a74fe92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74fe92",
  null
  
)

export default component.exports